import * as _ from 'lodash';

import { marketingFilesEndpoint } from 'models/api.model';
import { restEndpoint } from 'config';
import { MarketingFile } from 'models/brand/types';
import { getImageUrl } from 'helpers/image';
import { FileType, getFileType } from 'helpers/file-type';

export function getVideoThumbnailUrl(filename: string): string {
    const thumbnailUrlWithFilename = `${marketingFilesEndpoint}/videos/thumbnails/${filename}`;
    return `${restEndpoint}/internal${thumbnailUrlWithFilename}`;
}

export function getVideoThumbnailFilename(file: MarketingFile) {
    const thumbnailFilename = file.files[0]?.processedVideo?.thumbnails[0]?.filename;
    return hasVideoThumbnail(file) && thumbnailFilename ? thumbnailFilename : null;
}

export function hasVideoThumbnail(file: MarketingFile) {
    const extension = file.files[0]?.file?.extension;
    const fileType = getFileType(extension);
    return fileType === 'video' && _.has(file, 'files[0].processedVideo.thumbnails[0].filename');
}

export function getFilePreview(file: MarketingFile) {
    const videoThumbnailFilename = getVideoThumbnailFilename(file);

    if (getFileType(file.files[0].file.extension) === FileType.Video) {
        return videoThumbnailFilename ? getVideoThumbnailUrl(videoThumbnailFilename) : null;
    }

    return getImageUrl(file.files[0].file._id, 'thumb');
}
